import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function getToken() {
  return localStorage.getItem("falcom_admin_token");
}
export function setToken(t) {
  localStorage.setItem("falcom_admin_token", t);
}
export function clearToken() {
  localStorage.removeItem("falcom_admin_token");
}

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function getSessionId() {
  let id = localStorage.getItem("falcom_chat_session");
  if (!id) {
    id = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("falcom_chat_session", id);
  }
  return id;
}
